module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "gz-box",
    on: {
      "click": _vm.handleMaskClick
    }
  }, [_c('div', {
    staticClass: "gz-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleModalClick.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "gz-tabs"
  }, [_c('div', {
    staticClass: "gz-tab",
    class: {
      'gz-tab--active': _vm.currentTab === 0
    },
    on: {
      "click": function($event) {
        return _vm.switchTab(0)
      }
    }
  }, [_c('div', {
    staticClass: "gz-tab-item"
  }, [_c('span', {
    staticClass: "gz-tab-label"
  }, [_vm._v(_vm._s(_vm.$t('all.guanzhong')))]), _vm._v(" "), _c('span', {
    staticClass: "gz-tab-num"
  }, [_vm._v(_vm._s(_vm.followTotal))])]), _vm._v(" "), (_vm.currentTab === 0) ? _c('div', {
    staticClass: "gz-tab-line"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "gz-tab",
    class: {
      'gz-tab--active': _vm.currentTab === 1
    },
    on: {
      "click": function($event) {
        return _vm.switchTab(1)
      }
    }
  }, [_c('div', {
    staticClass: "gz-tab-item"
  }, [_c('span', {
    staticClass: "gz-tab-label"
  }, [_vm._v(_vm._s(_vm.$t('all.fensi')))]), _vm._v(" "), _c('span', {
    staticClass: "gz-tab-num"
  }, [_vm._v(_vm._s(_vm.fansTotal))])]), _vm._v(" "), (_vm.currentTab === 1) ? _c('div', {
    staticClass: "gz-tab-line"
  }) : _vm._e()]), _vm._v(" "), _c('img', {
    staticClass: "gz-close",
    attrs: {
      "src": require("../../assets/image/tanchuang_x_b@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleClose.apply(null, arguments)
      }
    }
  })]), _vm._v(" "), _c('div', {
    ref: "listContainer",
    staticClass: "gz-list",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "gz-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleGoUser(item)
        }
      }
    }, [_c('img', {
      staticClass: "gz-item-avatar",
      attrs: {
        "src": item.headPortrait,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "gz-item-info"
    }, [_c('span', {
      staticClass: "gz-item-nick"
    }, [_vm._v(_vm._s(item.nickName))]), _vm._v(" "), _c('span', {
      staticClass: "gz-item-uid"
    }, [_vm._v("ID " + _vm._s(item.recodeCode || item.userId))])]), _vm._v(" "), (_vm.currentTab === 0) ? _c('div', {
      staticClass: "gz-btn",
      class: item.followHe == 1 ? 'gz-btn--mutual' : 'gz-btn--followed',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleFollow(item, index)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.followHe == 1 ? _vm.$t('all.huguan') : _vm.$t('all.yiguanzhu')) + "\n\t\t\t\t")]) : _c('div', {
      staticClass: "gz-btn",
      class: item.followHe == 1 ? 'gz-btn--mutual' : 'gz-btn--follow',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleFollow(item, index)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.followHe == 1 ? _vm.$t('all.huguan') : _vm.$t('all.guanzhu')) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "gz-more-wrap"
    }, [_c('img', {
      staticClass: "gz-more",
      attrs: {
        "src": require("../../assets/image/dian_22_1@2x.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleMenu(index)
        }
      }
    }), _vm._v(" "), (_vm.menuIndex === index) ? _c('div', {
      staticClass: "gz-menu",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDelete(item, index)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.currentTab === 0 ? _vm.$t('all.shanchuguanzhu') : _vm.$t('all.yichufensi')) + "\n\t\t\t\t\t")]) : _vm._e()])])
  }), _vm._v(" "), (_vm.loaded && _vm.list.length === 0) ? _c('kong') : _vm._e()], 2)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98f7ce4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/guanzhu/guanzhu.vue
// module id = 1049
// module chunks = 1